module.exports = __webpack_public_path__ + "img/Crear Actividad Icono.7ceb6781.svg";